import { defineComponent as _defineComponent } from 'vue'
import { onMounted, onUnmounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseCountdownTimer',
  props: {
    endDate: null
  },
  setup(__props: any) {

const props = __props as {endDate: string}

const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;



const timer = ref<number>();

const days = ref(0);
const hours = ref(0);
const minutes = ref(0);
const seconds = ref(0);

const setTimers = () => {
	const currentTimeInMS = Date.now();
	const endDate = Date.parse(props.endDate);
	const timeDifference = endDate - currentTimeInMS;

	if (timeDifference <= 0) {
		days.value = 0;
		hours.value = 0;
		minutes.value = 0;
		seconds.value = 0;
		return clearTimer();
	}

	days.value = Math.floor(timeDifference / DAY);
	hours.value = Math.floor((timeDifference % DAY) / HOUR);
	minutes.value = Math.floor((timeDifference % HOUR) / MINUTE);
	seconds.value = Math.floor((timeDifference % MINUTE) / SECOND);
};

const clearTimer = () => {
	window.clearInterval(timer.value);
};

onMounted(() => {
	setTimers();
	timer.value = window.setInterval(() => {
		setTimers();
	}, 1000);         
});

onUnmounted(() => clearTimer());


return { __sfc: true,SECOND, MINUTE, HOUR, DAY, props, timer, days, hours, minutes, seconds, setTimers, clearTimer }
}

})